module.exports = __webpack_public_path__ + "assets/simple-arrow-right-fd2664.svg";